import { BasicRequest } from "./basicRequest";

export class PublishValidationDefinitionRequest extends BasicRequest{
    public validationDefinitionId!:number;
    public published:boolean = false;

    constructor(){
        super();
    }
}